Apt.fn.extend('account-post', {}, {
	/**
	 * Bind actions for the basic step
	 */
	basicSetup() {
		const scope = this;

		scope.bounds = null;
		scope.center = $.app.post.$get('data.center') || LS.user.center();

		scope.initTeams();
		scope.initUsers();
		scope.initSource();
		scope.initMls();
		scope.initLocation();
		scope.initMap();
		scope.initCenter();

		if (! scope.syndicated) {
			scope.initFormat();
			scope.initAuction();
		}
	},

	/**
	 * Initialize format
	 */
	initFormat() {
		$$('postFormat').on('click', (e, el) => {
			const format = el.dataset.value;

			$.app.post.$set('data.format', format);

			if (format === 'lease') {
				const lease = $.app.post.$set('data.lease', {});

				$.app.post.$set('data.lease', Object.assign({
					type: ''
				}, lease));
			}
		}, {
			namespace: 'post'
		});
	},

	/**
	 * Initialize auction
	 */
	initAuction() {
		$.events.on('$postAuctionFormat', 'change', (e, el) => {
			$.app.post.$set('data.auction.format', el.value);
		}, {
			delegate: this.$form,
			namespace: 'post'
		});
	},

	/**
	 * Initialize location
	 */
	initLocation() {
		const scope = this;
		const near = data => selection || data.center;

		let selection;

		scope.positioned = scope.id;
		scope.precision = 0;

		scope.locality = Apt.fn.locator()
			.init('$postLocality', {
				id: true,
				type: 'localities',
				center: near,
				changed: value => {
					selection = value.slug;

					$.app.post.$set('data.locality', value);

					if (value.parent) {
						value.parent.suffix = value.suffix;

						scope.subterritory.set(value.parent, true);
					}

					if (scope.precision < 2) {
						scope.precision = 1;

						if (! scope.positioned) {
							LS.location.entry(selection, data => {
								scope.setPosition(data.center);
							});
						}
					}
				}
			});

		scope.subterritory = Apt.fn.locator()
			.init('$postSubterritory', {
				id: true,
				type: 'subterritories',
				center: near,
				changed: value => {
					const locality = $.app.post.$get('data.locality');

					if (locality && value.suffix !== locality.suffix) {
						LS.util.warn('County and city states do not match');

						scope.subterritory.clear(true);

						return;
					}

					selection = value.slug;

					$.app.post.$set('data.subterritory', value);

					scope.bounds = null;

					LS.location.entry(selection, data => {
						scope.bounds = data.bounds;
					});
				}
			});

		scope.address = Apt.fn.locator()
			.init('$postAddress', {
				type: 'address',
				key: 'name',
				center: () => scope.center,
				changed: value => {
					if (scope.precision < 4) {
						scope.precision = 3;

						if (! scope.positioned) {
							scope.setPosition(value.center, 14);
						}
					}

					if (! value.feature) {
						return;
					}

					let subterritory;
					let locality;
					let postal;

					value.feature.context.forEach(item => {
						if (item.id.startsWith('district')) {
							subterritory = item.text;
						} else if (item.id.startsWith('place')) {
							locality = item.text;
						} else if (item.id.startsWith('region')) {
							const abbr = item.short_code.replace('US-', ' ');

							subterritory += abbr;
							locality += abbr;
						} else if (item.id.startsWith('postcode')) {
							postal = item.text;
						}
					});

					if (subterritory && ! $.app.post.$get('data.subterritory_id')) {
						scope.bounds = null;

						LS.location.entry(LS.util.slugify(subterritory), data => {
							scope.bounds = data.bounds;

							scope.subterritory.set(data, true);
						});
					}

					if (locality && ! $.app.post.$get('data.locality_id')) {
						LS.location.entry(LS.util.slugify(locality), data => {
							scope.locality.set(data, true);
						});
					}

					if (postal && ! $.app.post.$get('data.postal_code_id')) {
						LS.location.entry(postal, data => {
							scope.postal.set(data, true);
						});
					}
				}
			});

		scope.postal = Apt.fn.locator()
			.init('$postPostal', {
				id: true,
				type: 'postal_codes',
				center: near,
				changed: value => {
					if (value.parent) {
						const locality = $.app.post.$get('data.locality');

						if (locality && value.parent.suffix !== locality.suffix) {
							LS.util.warn('Zip code and city states do not match');

							scope.postal.clear(true);

							return;
						}
					}

					selection = value.slug;

					$.app.post.$set('data.postalCode', value);

					if (scope.precision < 3) {
						scope.precision = 2;

						if (! scope.positioned) {
							LS.location.entry(selection, data => {
								scope.setPosition(data.center, 12);
							});
						}
					}
				}
			});
	},

	/**
	 * Initialize map functionality
	 */
	initMap() {
		const scope = this;
		const center = scope.center || [-98.5795, 39.8282];

		LS.util.load('maps', () => {
			scope.map = Apt.fn.maps().init('$map', {
				basic: true,
				center: center,
				dragRotate: false,
				maxZoom: 9,
				style: 'dynamic',
				zoom: scope.center ?
					8 : 2,
				ready: () => {
					const map = scope.map;

					scope.canvas = map.map.getCanvas();

					scope.marker = {
						type: 'Feature',
						geometry: {
							type: 'Point',
							coordinates: center
						}
					};

					map.$private.addSource('marker', {
						type: 'geojson',
						data: scope.marker
					});

					map.$private.addLayer({
						id: 'marker',
						type: 'circle',
						source: 'marker',
						paint: {
							'circle-color': '#c77474',
							'circle-radius': 5,
							'circle-stroke-color': '#f2f9f5',
							'circle-stroke-opacity': 0.6,
							'circle-stroke-width': 10
						}
					});

					map.bind('marker', 'mouseenter', () => {
						scope.canvas.style.cursor = 'move';
					});

					map.bind('marker', 'mouseleave', () => {
						scope.canvas.style.cursor = '';
					});

					map.bind('marker', 'mousedown', e => {
						scope.canvas.style.cursor = 'grab';

						e.preventDefault();

						map.bind('map', 'mousemove', scope.markerMove);
						map.bind('map', 'mouseup', scope.markerStop, true);
					});

					map.bind('point', 'touchstart', e => {
						if (e.points.length !== 1) {
							return;
						}

						e.preventDefault();

						map.bind('map', 'touchmove', scope.markerMove);
						map.bind('map', 'touchend', scope.markerStop, true);
					});

					map.bind('map', 'mousedown', e => {
						const coords = e.lngLat;

						scope.positioned = true;

						scope.setPosition([
							coords.lng,
							coords.lat
						], 8);
					});
				}
			});
		});
	},

	/**
	 * Set marker center
	 *
	 * @param {Array} center
	 * @param {Boolean|Number} [zoom=10]
	 */
	setPosition(center, zoom = 10) {
		const scope = this;
		const form = scope.$form[0];

		scope.center = center = [
			LS.util.round(center[0], 6),
			LS.util.round(center[1], 6)
		];

		$.app.post.$set('data.center', center);

		form.longitude.value = scope.center[0];
		form.latitude.value = scope.center[1];

		if (scope.marker) {
			scope.marker.geometry.coordinates = center;

			scope.map.map.getSource('marker')
				.setData(scope.marker);
		}

		if (zoom !== false) {
			if (scope.map) {
				const current = scope.map.getZoom();
				const target = Math.max(current, zoom);

				if (current !== target || ! scope.map.map.getBounds().contains(center)) {
					scope.map.center(center, {
						zoom: target
					});
				}
			}
		} else {
			scope.precision = 4;
		}
	},

	/**
	 * Move the marker
	 *
	 * @param {Object} e
	 */
	markerMove(e) {
		const scope = Apt['account-post'].$private;

		scope.canvas.style.cursor = 'grabbing';

		scope.marker.geometry.coordinates = [
			e.lngLat.lng,
			e.lngLat.lat
		];

		scope.map.map.getSource('marker')
			.setData(scope.marker);
	},

	/**
	 * Stop the marker movement
	 *
	 * @param {Object} e
	 */
	markerStop(e) {
		const scope = Apt['account-post'].$private;

		scope.positioned = true;

		scope.setPosition([
			e.lngLat.lng,
			e.lngLat.lat
		], false);

		scope.canvas.style.cursor = '';

		scope.map.unbind('map', 'mousemove', scope.markerMove);
		scope.map.unbind('map', 'touchmove', scope.markerStop);
	},

	/**
	 * Initialize center
	 */
	initCenter() {
		const scope = this;
		const form = scope.$form[0];

		$$('center').on('change', () => {
			const lat = form.latitude.value.trim();
			const lon = form.longitude.value.trim();

			if (lat && ! scope.validateLatitude()) {
				form.latitude.value = '';

				return;
			}

			if (lon && ! scope.validateLongitude()) {
				form.longitude.value = '';

				return;
			}

			if (lat && lon) {
				if (! scope.validateCenter()) {
					return;
				}

				scope.setPosition([
					lon,
					lat
				]);
			}
		});
	},

	/**
	 * Initialize teams
	 */
	initTeams() {
		const scope = this;
		const team = $.app.post.$get('data.team');

		if (team) {
			$.app.post.$set('teams', [
				team
			]);
		}

		if (scope.locked) {
			return;
		}

		const id = $.app.post.$get('data.team_id');

		let teams;

		LS.api.get('me/teams', {
			auth: true,
			success: data => {
				teams = data.results;
				scope.teams = LS.util.key(teams);

				if (teams.length && (! id || scope.teams[id])) {
					if ($.app.post.$get('teams')) {
						$.app.post.$drop('teams');
					}

					teams.unshift({
						id: '',
						name: 'Not applicable'
					});

					$.app.post.$set('teams', teams);
				}

				scope.loadUsers(id);
			}
		});

		$.app.post.$observe('data.team_id', value => {
			scope.loadUsers(value, true);
		});
	},

	/**
	 * Initialize users
	 */
	initUsers() {
		const scope = this;
		const key = 'data.agents';
		const users = $.app.post.$get(key);

		if (users) {
			$.app.post.$set('users', users);
		}

		if (scope.syndicated) {
			return;
		}

		$.events.on({
			'$addAgent': {
				click: () => {
					$.app.post.$push(key, {
						id: '',
						uid: LS.util.uid()
					});
				}
			},
			'$deleteAgent': {
				click: (e, el) => {
					$.app.post.$drop(key + '.' + $(el).parent().index());
				}
			}
		}, {
			delegate: scope.$form,
			namespace: 'post'
		});
	},

	/**
	 * Load users
	 *
	 * @param {Number} team
	 * @param {Boolean} [reset=false]
	 */
	loadUsers(team, reset) {
		if (! team) {
			$.app.post.$drop('data.agents');

			return;
		}

		LS.api.get(`me/teams/${team}/users`, {
			auth: true,
			data: {
				limit: null
			},
			success: data => {
				const users = data.results;

				if (users && users.length > 1) {
					users.unshift({
						id: '',
						name: 'Select one'
					});
				}

				if ($.app.post.$get('users')) {
					$.app.post.$drop('users');
				}

				$.app.post.$set('users', users);

				if (users && reset) {
					$.app.post.$set('data.agents', [
						{
							id: users.length === 1 ?
								users[0].id : ''
						}
					]);
				}
			}
		});
	},

	/**
	 * Initialize source
	 */
	initSource() {
		const scope = this;

		if (scope.id) {
			return;
		}

		let previousKey;
		let previousUrl;

		$$('postSource').on('blur', () => {
			const key = $.app.post.$get('data.listing_key');
			const url = $.app.post.$get('data.source_url');

			if (
				(key && key !== previousKey) ||
				(url && url !== previousUrl)
			) {
				previousKey = key;
				previousUrl = url;

				scope.lookup();
			}
		}, {
			namespace: 'post'
		});
	},

	/**
	 * Initialize MLS
	 */
	initMls() {
		const scope = this;

		if (scope.id) {
			return;
		}

		let previous;

		$$('postMls').on('blur', () => {
			const mls = $.app.post.$get('data.mls');
			const number = $.app.post.$get('data.mls_number');

			if (mls && number && (mls + number !== previous)) {
				previous = mls + number;

				scope.lookup();
			}
		}, {
			namespace: 'post'
		});
	},


	/**
	 * Validate location
	 *
	 * @returns {boolean}
	 */
	validateLocation() {
		const scope = this;

		let address;

		if (! scope.locality.val()) {
			LS.util.warn('City selection is invalid');

			scope.locality.highlight();

			return false;
		}

		if (! scope.subterritory.val()) {
			LS.util.warn('County selection is invalid');

			scope.subterritory.highlight();

			return false;
		}

		if (! scope.address.val()) {
			address = scope.address.text();

			if (address && address.includes(',')) {
				LS.util.warn('Only base address allowed — no commas');

				scope.address.highlight();

				return false;
			}
		}

		if (scope.bounds && scope.map) {
			try {
				const bounds = new maplibregl.LngLatBounds(scope.bounds);

				if (! bounds.contains(scope.map.getCenter())) {
					LS.util.warn('Coordinates and county do not match');

					return false;
				}
			} catch (e) {
				//
			}
		}

		return true;
	},

	/**
	 * Validate latitude
	 *
	 * @returns {Boolean}
	 */
	validateLatitude() {
		const value = this.$form[0].latitude.value.trim();

		let error;

		if (value.includes('°')) {
			error = 'Latitude must be decimal formatted';
		} else if (! /^-?[.\d]+$/.test(value)) {
			error = 'Latitude is invalid';
		} else if (
			value < -90 ||
			value > 90
		) {
			error = 'Latitude must be between -90 and 90';
		}

		if (error) {
			LS.util.warn(error);

			LS.validate.highlight('#latitude', true);

			return false;
		}

		return true;
	},

	/**
	 * Validate longitude
	 *
	 * @returns {Boolean}
	 */
	validateLongitude() {
		const value = this.$form[0].longitude.value.trim();

		let error;

		if (value.includes('°')) {
			error = 'Longitude must be decimal formatted';
		} else if (! /^-?[.\d]+$/.test(value)) {
			error = 'Longitude is invalid';
		} else if (
			value < -180 ||
			value > 180
		) {
			error = 'Longitude must be between -180 and 180';
		}

		if (error) {
			LS.util.warn(error);

			LS.validate.highlight('#longitude', true);

			return false;
		}

		return true;
	},

	/**
	 * Validate center
	 *
	 * @returns {Boolean}
	 */
	validateCenter() {
		try {
			const form = this.$form[0];

			new maplibregl.LngLat(
				form.longitude.value,
				form.latitude.value
			);
		} catch (e) {
			LS.util.warn('Coordinates are invalid');

			LS.validate.highlight('#latitude', true);

			return false;
		}

		return true;
	},

	/**
	 * Validate basic step
	 *
	 * @returns {Boolean}
	 */
	basicValidate() {
		const scope = this;

		if (scope.access && ! scope.access.user.total) {
			const teamId = $.app.post.$get('data.team_id');

			if (! teamId) {
				LS.util.warn('Select a team with available credits or promotions');

				return false;
			}

			const teamAccess = scope.access.teams[teamId] || {};

			if (! teamAccess.total) {
				LS.util.warn('The selected team has no available credits or promotions');

				return false;
			}
		}

		if (! scope.syndicated) {
			const agents = $.app.post.$get('data.agents');

			if (agents) {
				const agentIds = LS.util.pluck(agents, 'id');

				if (agentIds.some((val, i) => agentIds.indexOf(val) !== i)) {
					LS.util.warn('Users cannot be repeated');

					return false;
				}
			}

			const sourceUrl = $.app.post.$get('data.source_url');

			if (sourceUrl && new RegExp('(^|https?\/\/(www\.)?|www\.)(crexi|homes|land(andfarm|flip|watch)?|trulia|realtor|zillow)\.com', 'i').test(sourceUrl)) {
				LS.util.warn('Source URL cannot include a marketplace');

				return false;
			}

			const source = $.app.post.$get('data.listing_source');
			const mlsNumber = $.app.post.$get('data.mls_number');

			// if ((source || mlsNumber) && (! source || ! mlsNumber)) { // TODO revert
			if (source && ! mlsNumber) {
				const missing = source ?
					'number' : 'source';

				LS.validate.highlight(source ? '#mls_number' : '#listing_source', true);

				LS.util.warn(`MLS ${missing} is missing`);

				return false;
			}

			if ($.app.post.$get('data.format') === 'auction') {
				const auction = $.app.post.$get('data.auction');

				if (auction.ends_at_date && ! auction.ends_at_time) {
					LS.util.warn('Auction end time is required when end date is set');

					return false;
				}
			}

			if (scope.id) {
				const current = $.app.post.$get('original.price');
				const updated = $.app.post.$get('data.price');

				if (current && updated && Math.abs((updated - current) / current) > 0.5) {
					LS.util.warn('Price change requires verification — contact support', {
						id: scope.id,
						price: updated
					});

					return false;
				}
			}

			if (! scope.validateLocation()) {
				return false;
			}

			if (
				! scope.validateLatitude() ||
				! scope.validateLongitude() ||
				! scope.validateCenter()
			) {
				return false;
			}
		}

		if (! scope.validateStep()) {
			return false;
		}

		if (! scope.id && ! scope.checked) {
			scope.checked = true;

			scope.lookup();
		}

		return true;
	},

	/**
	 * Check for existing listing
	 */
	lookup() {
		const scope = this;

		LS.api.post('me/listings/lookup', {
			auth: true,
			flash: false,
			data: LS.util.sanitize({
				center: $.app.post.$get('data.center'),
				key: $.app.post.$get('data.listing_key'),
				mls: $.app.post.$get('data.mls'),
				mls_number: $.app.post.$get('data.mls_number'),
				price: $.app.post.$get('data.price'),
				size: $.app.post.$get('data.size'),
				source_url: $.app.post.$get('data.source_url'),
				team: $.app.post.$get('data.team_id'),
				user: LS.user.get('id')
			}),
			success: data => {
				if (data.results && data.results.length) {
					const ids = LS.util.pluck(data.results, 'id');

					if (scope.lookupIds && $.equals(scope.lookupIds, ids)) {
						return;
					}

					scope.lookupIds = ids;

					data.results.forEach(result => {
						Apt.properties.transform(result);
					});

					LS.modal.open({
						model: {
							title: 'Possible duplicate',
							content: $.view.render('account-post.modals.lookup', {
								results: data.results
							})
						},
						width: 520
					});
				}
			}
		});
	}
});